module.exports = __webpack_public_path__ + "static/media/carnes-validadas-logo-qr-v2.2cb8932b.png";